export default "__VITE_ASSET__CxeaZRlY__"